// tslint:disable
export var States;
(function (States) {
    // UNKN
    States[States["UNKNOWN"] = 0] = "UNKNOWN";
    // AL
    States[States["ALABAMA"] = 1] = "ALABAMA";
    // AK
    States[States["ALASKA"] = 2] = "ALASKA";
    // AS
    States[States["AMERICANSAMOA"] = 3] = "AMERICANSAMOA";
    // AZ
    States[States["ARIZONA"] = 4] = "ARIZONA";
    // AR
    States[States["ARKANSAS"] = 5] = "ARKANSAS";
    // CA
    States[States["CALIFORNIA"] = 6] = "CALIFORNIA";
    // CO
    States[States["COLORADO"] = 7] = "COLORADO";
    // CT
    States[States["CONNECTICUT"] = 8] = "CONNECTICUT";
    // DE
    States[States["DELAWARE"] = 9] = "DELAWARE";
    // DC
    States[States["DISTRICTOFCOLUMBIA"] = 10] = "DISTRICTOFCOLUMBIA";
    // FM
    States[States["FEDERATEDSTATESOFMICRONESIA"] = 11] = "FEDERATEDSTATESOFMICRONESIA";
    // FL
    States[States["FLORIDA"] = 12] = "FLORIDA";
    // GA
    States[States["GEORGIA"] = 13] = "GEORGIA";
    // GU
    States[States["GUAM"] = 14] = "GUAM";
    // HI
    States[States["HAWAII"] = 15] = "HAWAII";
    // ID
    States[States["IDAHO"] = 16] = "IDAHO";
    // IL
    States[States["ILLINOIS"] = 17] = "ILLINOIS";
    // IN
    States[States["INDIANA"] = 18] = "INDIANA";
    // IA
    States[States["IOWA"] = 19] = "IOWA";
    // KS
    States[States["KANSAS"] = 20] = "KANSAS";
    // KY
    States[States["KENTUCKY"] = 21] = "KENTUCKY";
    // LA
    States[States["LOUISIANA"] = 22] = "LOUISIANA";
    // ME
    States[States["MAINE"] = 23] = "MAINE";
    // MH
    States[States["MARSHALLISLANDS"] = 24] = "MARSHALLISLANDS";
    // MD
    States[States["MARYLAND"] = 25] = "MARYLAND";
    // MA
    States[States["MASSACHUSETTS"] = 26] = "MASSACHUSETTS";
    // MI
    States[States["MICHIGAN"] = 27] = "MICHIGAN";
    // MN
    States[States["MINNESOTA"] = 28] = "MINNESOTA";
    // MS
    States[States["MISSISSIPPI"] = 29] = "MISSISSIPPI";
    // MO
    States[States["MISSOURI"] = 30] = "MISSOURI";
    // MT
    States[States["MONTANA"] = 31] = "MONTANA";
    // NE
    States[States["NEBRASKA"] = 32] = "NEBRASKA";
    // NV
    States[States["NEVADA"] = 33] = "NEVADA";
    // NH
    States[States["NEWHAMPSHIRE"] = 34] = "NEWHAMPSHIRE";
    // NJ
    States[States["NEWJERSEY"] = 35] = "NEWJERSEY";
    // NM
    States[States["NEWMEXICO"] = 36] = "NEWMEXICO";
    // NY
    States[States["NEWYORK"] = 37] = "NEWYORK";
    // NC
    States[States["NORTHCAROLINA"] = 38] = "NORTHCAROLINA";
    // ND
    States[States["NORTHDAKOTA"] = 39] = "NORTHDAKOTA";
    // MP
    States[States["NORTHERNMARIANAISLANDS"] = 40] = "NORTHERNMARIANAISLANDS";
    // OH
    States[States["OHIO"] = 41] = "OHIO";
    // OK
    States[States["OKLAHOMA"] = 42] = "OKLAHOMA";
    // OR
    States[States["OREGON"] = 43] = "OREGON";
    // PW
    States[States["PALAU"] = 44] = "PALAU";
    // PA
    States[States["PENNSYLVANIA"] = 45] = "PENNSYLVANIA";
    // PR
    States[States["PUERTORICO"] = 46] = "PUERTORICO";
    // RI
    States[States["RHODEISLAND"] = 47] = "RHODEISLAND";
    // SC
    States[States["SOUTHCAROLINA"] = 48] = "SOUTHCAROLINA";
    // SD
    States[States["SOUTHDAKOTA"] = 49] = "SOUTHDAKOTA";
    // TN
    States[States["TENNESSEE"] = 50] = "TENNESSEE";
    // TX
    States[States["TEXAS"] = 51] = "TEXAS";
    // UT
    States[States["UTAH"] = 52] = "UTAH";
    // VT
    States[States["VERMONT"] = 53] = "VERMONT";
    // VI
    States[States["VIRGINISLANDS"] = 54] = "VIRGINISLANDS";
    // VA
    States[States["VIRGINIA"] = 55] = "VIRGINIA";
    // WA
    States[States["WASHINGTON"] = 56] = "WASHINGTON";
    // WV
    States[States["WESTVIRGINIA"] = 57] = "WESTVIRGINIA";
    // WI
    States[States["WISCONSIN"] = 58] = "WISCONSIN";
    // WY
    States[States["WYOMING"] = 59] = "WYOMING";
    // AA
    States[States["ARMEDFORCESAMERICAS"] = 60] = "ARMEDFORCESAMERICAS";
    // AE
    States[States["ARMEDFORCESEUROPE"] = 61] = "ARMEDFORCESEUROPE";
    // AP
    States[States["ARMEDFORCESPACIFIC"] = 62] = "ARMEDFORCESPACIFIC";
})(States || (States = {}));
//# sourceMappingURL=States.js.map